import type { SituacaoOpMaquina } from '@/types/dashboards';
import type { FaixaMfr } from '@/utils/equiplexMaquinas';
import { STATUS, corNeutra, type ModoTema, type VisualFaixa } from '../chartTheme';

/** Faixa do MFR: sempre ícone + rótulo (e o número ao lado), nunca só a cor. */
export function visualFaixaMfr(faixa: FaixaMfr): VisualFaixa {
  switch (faixa) {
    case 'critico':
      return { rotulo: 'Crítico', icone: 'error', cor: STATUS.critico };
    case 'alerta':
      return { rotulo: 'Alerta', icone: 'warning', cor: STATUS.atencao };
    default:
      return { rotulo: 'No ritmo', icone: 'check_circle', cor: STATUS.bom };
  }
}

/** Situação da OP na tabela. Só a "encerrada sem produzir" sai do programado. */
export function visualSituacaoOp(situacao: SituacaoOpMaquina, modo: ModoTema): VisualFaixa {
  switch (situacao) {
    case 'produziu':
      return { rotulo: 'Produziu', icone: 'check_circle', cor: STATUS.bom };
    case 'iniciada_sem_apontamento':
      return { rotulo: 'Iniciada sem apontamento', icone: 'report', cor: STATUS.critico };
    case 'nao_iniciada':
      return { rotulo: 'Não iniciada', icone: 'hourglass_empty', cor: STATUS.atencao };
    case 'encerrada_sem_produzir':
      return { rotulo: 'Encerrada sem produzir', icone: 'block', cor: corNeutra(modo) };
    case 'em_aberto':
      return { rotulo: 'Em aberto', icone: 'schedule', cor: corNeutra(modo) };
    default:
      return { rotulo: 'Programada', icone: 'event', cor: corNeutra(modo) };
  }
}

/** Fundo translúcido da célula da matriz (o número continua em cor de texto). */
export const fundoFaixa = (cor: string): string => `${cor}2e`;
